// A4 dimensions in mm
export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;

// Letter dimensions in mm
export const LETTER_WIDTH_MM = 215.9;
export const LETTER_HEIGHT_MM = 279.4;

// Default scale for preview (pixels per mm)
export const PREVIEW_SCALE = 3;

// Default margins in mm
export const DEFAULT_MARGINS = {
  top: 20,
  right: 15,
  bottom: 20,
  left: 15
};

// Page formats
export const PAGE_FORMATS = {
  A4: { width: A4_WIDTH_MM, height: A4_HEIGHT_MM, label: 'A4' },
  LETTER: { width: LETTER_WIDTH_MM, height: LETTER_HEIGHT_MM, label: 'Letter' }
};

// Orientations
export const ORIENTATIONS = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape'
};

// Default font settings
export const DEFAULT_FONT = {
  family: 'Arial',
  size: 12,
  weight: 'normal',
  style: 'normal',
  color: '#000000'
};

// Available fonts
export const FONT_FAMILIES = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Georgia',
  'Courier New',
  'Verdana',
  'Tahoma'
];

// Font sizes
export const FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 72];

// Element types
export const ELEMENT_TYPES = {
  TEXT: 'text',
  DATA_FIELD: 'dataField',
  TABLE: 'table',
  IMAGE: 'image',
  LINE: 'line',
  RECTANGLE: 'rectangle',
  PAGE_NUMBER: 'pageNumber'
};

// Layout zones
export const LAYOUT_ZONES = {
  HEADER: 'header',
  BODY: 'body',
  FOOTER: 'footer'
};


// Filter operators
export const FILTER_OPERATORS = [
  { value: 'value', label: '= Uguale' },
  { value: 'different_from_value', label: '!= Diverso' },
  { value: 'greater', label: '> Maggiore di' },
  { value: 'minor', label: '< Minore di' },
  { value: 'like', label: 'Contiene' },
  { value: 'start', label: 'Inizia con' },
  { value: 'end', label: 'Finisce con' },
  { value: 'isnull', label: 'E\' vuoto' },
  { value: 'in', label: 'In lista' }
];

// Aggregation functions
export const AGGREGATIONS = [
  { value: 'none', label: 'Nessuna' },
  { value: 'COUNT', label: 'Conta' },
  { value: 'SUM', label: 'Somma' },
  { value: 'AVG', label: 'Media' },
  { value: 'MIN', label: 'Minimo' },
  { value: 'MAX', label: 'Massimo' }
];

// Numeric types that support aggregation
export const NUMERIC_TYPES = ['number', 'float', 'currency'];

// Text align options
export const TEXT_ALIGNMENTS = [
  { value: 'left', label: 'Sinistra', icon: 'align-left' },
  { value: 'center', label: 'Centro', icon: 'align-center' },
  { value: 'right', label: 'Destra', icon: 'align-right' },
  { value: 'justify', label: 'Giustifica', icon: 'align-justify' }
];

// Border styles
export const BORDER_STYLES = [
  { value: 'none', label: 'Nessuno' },
  { value: 'solid', label: 'Continuo' },
  { value: 'dashed', label: 'Tratteggiato' },
  { value: 'dotted', label: 'Punteggiato' }
];

// Generate unique ID
export const generateId = () => {
  return 'el_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// Convert mm to pixels for preview
export const mmToPx = (mm, scale = PREVIEW_SCALE) => {
  return mm * scale;
};

// Convert pixels to mm
export const pxToMm = (px, scale = PREVIEW_SCALE) => {
  return px / scale;
};

// Get page dimensions based on format and orientation
export const getPageDimensions = (format, orientation) => {
  const page = PAGE_FORMATS[format] || PAGE_FORMATS.A4;
  if (orientation === ORIENTATIONS.LANDSCAPE) {
    return { width: page.height, height: page.width };
  }
  return { width: page.width, height: page.height };
};

// Default report state
export const DEFAULT_REPORT_STATE = {
  name: 'Nuovo Report',
  description: '',
  pageSettings: {
    format: 'A4',
    orientation: ORIENTATIONS.PORTRAIT,
    margins: { ...DEFAULT_MARGINS }
  },
  query: {
    entity: null,
    selectedFields: [],
    filters: [],
    joins: [],
    groupBy: [],
    orderBy: []
  },
  layout: {
    body: {
      elements: []
    }
  }
};
